const DEVICE_LABEL_PREFERENCE_KEY = 'circlus.preferredDeviceLabel';
const DEVICE_LABEL_MAX_LENGTH = 80;

export function normalizeDeviceLabel(value: string | null | undefined): string {
  return String(value || '').trim().slice(0, DEVICE_LABEL_MAX_LENGTH);
}

export function getPreferredDeviceLabel(): string {
  try {
    return normalizeDeviceLabel(localStorage.getItem(DEVICE_LABEL_PREFERENCE_KEY));
  } catch {
    return '';
  }
}

export function rememberPreferredDeviceLabel(value: string | null | undefined): void {
  const normalized = normalizeDeviceLabel(value);
  if (!normalized) return;
  try {
    localStorage.setItem(DEVICE_LABEL_PREFERENCE_KEY, normalized);
  } catch {
    // ignore
  }
}
